import { IconComponent } from './types';

const CardIcon: IconComponent = (props) => (
  <svg
    width={14}
    height={14}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M467.8 60.4H45c-25.2 0-45 20.5-45 45v301.3c0 25.2 20.5 45 45 45h422c25.2 0 45-20.5 45-45V106.1c.8-25.2-19.7-45.7-44.2-45.7zm15 347.1c0 8.7-7.1 15-15 15H45c-8.7 0-15-7.1-15-15V241.8h452.8v165.7zM30 151.1v-45c0-8.7 7.1-15 15-15h422c8.7 0 15 7.1 15 15v45H30z" />
  </svg>
);

export default CardIcon;
